<div> <!-- TODO review <app-reactive-dialog-component [data]="dialogInputData"> -->
  <div class="gsm-abort-dialog-container">
    <h2 mat-dialog-title *ngIf="dialogInputData.title">{{ dialogInputData.title }}</h2>
    <p class="mat-subheading-2 gsm-abort-dialog-warning_wrapper">
      <mat-icon color="warn" class="gsm-abort-dialog-warning_icon" inline>warning</mat-icon>
      <span [innerHTML]="dialogInputData.text_pre" class="warning-text"></span>
    </p>
    <div *ngIf="dialogInputData.text_post" class="gsm-abort-dialog-message_container">
      <div class="message-container_confirm_text">
        {{ dialogInputData.text_post }}
      </div>
      <button mat-fab class="message-container_confirm_text_button" matTooltip="Zum Speichern klicken"
              type="button" (click)="onSaveClick()">
        <mat-icon>save</mat-icon>
      </button>
    </div>
    <div class="buttons-container">
      <button mat-raised-button color="accent"
              (click)="onAccept()">{{ dialogInputData.buttonConfig.actionButtons[0].name }}
      </button>
      <button *ngIf="dialogInputData.buttonConfig.actionButtons[1]" mat-raised-button class="mat-gray-bg"
              (click)="onCancelClick()">{{ dialogInputData.buttonConfig.actionButtons[1].name }}
      </button>
    </div>
  </div>
</div>

